(() => {
  const STYLE_ID = 'oseaTrustTextBounceStyles';

  const syncHeroPricing = () => {
    const heroHandles = [
      'toalla-elite-classic-jumbo-economica',
      'papel-higienico-elite-classic-jumbo',
      'jabon-elite-economico-granel'
    ];

    const slides = [...document.querySelectorAll('.osea-hero-slide')];
    if (!slides.length) return;

    heroHandles.forEach((handle, index) => {
      const slide = slides[index];
      const sourceCard = document.querySelector(`.osea-product-card[data-product-handle="${handle}"]`);
      const meta = slide?.querySelector('.osea-hero-product-meta');
      if (!slide || !sourceCard || !meta) return;

      const sourcePrice = sourceCard.querySelector('.osea-product-card__price');
      const sourceNet = sourceCard.querySelector('.osea-product-card__net');
      const heroPrice = meta.querySelector('span');
      const heroNet = meta.querySelector('small');

      if (sourcePrice && heroPrice) {
        const grossText = sourcePrice.textContent.replace(/\(IVA incluido\)/gi, '').trim();
        if (grossText) heroPrice.textContent = grossText;
      }

      if (sourceNet && heroNet) {
        const netText = sourceNet.textContent.replace(/^\s*\*?Valor neto:\s*/i, '').trim();
        if (netText) heroNet.textContent = `IVA incluido · Neto ${netText}`;
      }
    });
  };

  const setupTrustTextBounce = () => {
    const strip = document.querySelector('.osea-trust-strip');
    const viewport = strip?.querySelector('.osea-trust-strip__viewport');
    const track = viewport?.querySelector('.osea-trust-strip__track');
    if (!strip || !viewport || !track) return false;
    if (track.dataset.oseaTrustBounce === 'ready') return true;

    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        .osea-trust-strip__viewport{
          overflow:hidden!important;
          -webkit-mask-image:none!important;
          mask-image:none!important;
        }
        .osea-trust-strip__track.osea-trust-text-bounce{
          display:flex!important;
          width:max-content!important;
          min-width:max-content!important;
          align-items:center!important;
          will-change:transform;
          animation:oseaTrustTextCornerBounce var(--osea-trust-text-duration,24s) cubic-bezier(.45,.04,.55,.96) infinite alternate!important;
        }
        .osea-trust-strip__track.osea-trust-text-bounce .osea-trust-strip__group{
          flex:none!important;
        }
        .osea-trust-strip:hover .osea-trust-strip__track.osea-trust-text-bounce{
          animation-play-state:running!important;
        }
        @keyframes oseaTrustTextCornerBounce{
          0%{transform:translate3d(0,-2px,0)}
          100%{transform:translate3d(var(--osea-trust-text-end,0px),2px,0)}
        }
        @media(prefers-reduced-motion:reduce){
          .osea-trust-strip__track.osea-trust-text-bounce{
            animation:none!important;
            transform:none!important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    const templateGroup = track.querySelector('.osea-trust-strip__group')?.cloneNode(true);
    track.classList.add('osea-trust-text-bounce');
    track.dataset.oseaTrustBounce = 'ready';

    const updateTrack = () => {
      if (templateGroup) {
        let safety = 0;
        const targetWidth = Math.max(viewport.clientWidth * 2.6, 1800);
        while (track.scrollWidth < targetWidth && safety < 12) {
          const clone = templateGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.oseaTrustClone = 'true';
          track.appendChild(clone);
          safety += 1;
        }
      }

      requestAnimationFrame(() => {
        const travel = Math.max(0, track.scrollWidth - viewport.clientWidth);
        const duration = Math.max(18, Math.min(30, travel / 72));
        track.style.setProperty('--osea-trust-text-end', `-${travel}px`);
        track.style.setProperty('--osea-trust-text-duration', `${duration.toFixed(1)}s`);
      });
    };

    updateTrack();

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateTrack);
      observer.observe(viewport);
    } else {
      window.addEventListener('resize', updateTrack, { passive: true });
    }

    return true;
  };

  const boot = () => {
    syncHeroPricing();
    window.setTimeout(syncHeroPricing, 250);

    if (setupTrustTextBounce()) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (setupTrustTextBounce() || attempts >= 12) window.clearInterval(timer);
    }, 120);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
